import BrokerTower from "./BrokerTower";
import TextNote from "components/common/TextNote";
import Visible from "components/common/Visible";
import SelfInsuredRetentions from "components/inputs/claims/SelfInsuredRetentions";
import ParticipationTable from "components/pricing/towerPricing/ParticipationTable";
import TowerRateChart from "components/pricing/towerPricing/TowerRateChart";
import * as labels from "config.labels";
import * as staticDataHooks from "store/hooks/staticDataHooks";

export const BrokerTowerTab = () => {
  const translateLabel = staticDataHooks.useTranslator("uiLabels");
  return (
    <>
      <Visible byTag={"inputs.brokerTower.SIR"}>
        <SelfInsuredRetentions />
      </Visible>
      <BrokerTower
        title={translateLabel(labels.TOWER_PRICING_TOWER_LAYERS_TITLE, {
          default: "Tower of Layers",
        })}
        subtitle={translateLabel(labels.TOWER_PRICING_TOWER_LAYERS_SUBTITLE, {
          default: "The layers that are being placed in the market.",
        })}
      />
      <Visible byTag={"inputs.brokerTower.towerNote"} defaultVisible>
        <TextNote
          noteKey={"tower"}
          title={translateLabel(labels.TOWER_PRICING_TOWER_LAYERS_TITLE, {
            default: "Notes",
          })}
        />
      </Visible>
      <Visible byTag={"inputs.brokerTower.towerRateChart"} defaultVisible>
        <TowerRateChart />
      </Visible>
      <Visible byTag={"inputs.brokerTower.participationTable"} defaultVisible>
        <ParticipationTable />
      </Visible>
    </>
  );
};

export default BrokerTowerTab;
